import React from 'react';

type IconAffixProps = {
    children: React.ReactNode;
    className?: string;
    prefix?: boolean;
    suffix?: boolean;
};

export function IconAffix(props: IconAffixProps) {
    const { children, className = '' } = props;

    const affixBase = props.prefix
        ? 'prefix prefix--icon'
        : 'suffix suffix--icon';
    const affixClass = `${affixBase} ${className}`;

    return (
        <div className={affixClass}>
            <span className={props.prefix ? 'prefix--label' : 'suffix--label'}>
                {children}
            </span>
        </div>
    );
}
